import { useTranslation } from 'react-i18next';

import { useHistory } from '@treams/treams-routes';

import * as graphql from 'generated/graphql';
import useAuthenticatedUser from 'packages/kakapo-ui-application/hooks/useAuthenticatedUser';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import { useMixpanel } from 'packages/kakapo-ui-application/hooks/useMixpanel';

import InboxTaskItem from '../components/InboxTaskItem';

export default function InboxMomentStartTask({
	task,
	onAction,
	refresh,
}: {
	task: graphql.InboxTask;
	onAction: () => void;
	refresh: () => void;
}) {
	const mixpanel = useMixpanel();
	const history = useHistory();
	const { t } = useTranslation();
	const authenticatedUser = useAuthenticatedUser();
	const { localize } = useLocalize();

	const [completeMomentInstance] = graphql.useCompleteMomentInstanceTaskMutation();

	const { moment: momentInstance } = task;

	const { id, momentTemplate } = momentInstance!;
	const { type, title } = momentTemplate;

	const onClick = async () => {
		onAction();
		switch (type) {
			case graphql.MomentType.Goals:
				mixpanel?.track('inbox.tasks.moments.goals.start');
				history.push(`/user/${authenticatedUser.id}/goals/create-from-moment/${id}`);
				break;
			case graphql.MomentType.Feedback:
				mixpanel?.track('inbox.tasks.moments.feedback.start');
				history.push(`/user/${authenticatedUser.id}/feedback-v2/request-from-moment/${id}`);
				break;
			case graphql.MomentType.Evaluation:
				mixpanel?.track('inbox.tasks.moments.evaluation.start');
				history.push(`/user/${authenticatedUser.id}/evaluations-v2/request-from-moment/${id}`);
				break;
			case graphql.MomentType.Message:
				mixpanel?.track('inbox.tasks.moments.message.start');
				await completeMomentInstance({
					variables: {
						input: {
							id,
						},
					},
				});
				refresh();
				break;
			default:
				break;
		}
	};

	let key: string | undefined;
	let buttonTitle = t('inbox.tasks.button.start');

	switch (type) {
		case graphql.MomentType.Goals:
			key = 'goal';
			break;
		case graphql.MomentType.Feedback:
			key = 'feedback';
			break;
		case graphql.MomentType.Evaluation:
			key = 'evaluation';
			break;
		case graphql.MomentType.Message:
			key = 'message';
			buttonTitle = t('inbox.tasks.button.complete');
			break;
		default:
			break;
	}

	return (
		<InboxTaskItem
			task={task}
			title={t(`inbox.tasks.${key}StartMomentSelf.title`, {
				momentName: localize(title).text,
			})}
			date={task.createdAt}
			instruction={momentTemplate.description ?? undefined}
			buttonTitle={buttonTitle}
			onClick={onClick}
			refresh={refresh}
		/>
	);
}
